module.exports = __webpack_public_path__ + "static/media/screenshots-min.e4dcc83e.png";